export const DEFAULT_MARGIN = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
};
export const LEGEND_WIDTH = 150;
export const STACK_GAP = 1;
export const STACK_GAP_PROGRESS_BAR = 2;
export const CORNER_RADIUS_VALUE = {
  SMALL: 2,
  MEDIUM: 4,
  LARGE: 8,
  NONE: 0
};